import React, { Component } from 'react';
import {
    Form,
    Button,
    Row,
    Col,
    Card,
    Alert,
    Modal,
    Badge
} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import CurrencyInput from 'react-currency-input-field';
import {
    FaExchangeAlt,
    FaMoneyBillWave,
    FaWallet,
    FaArrowRight,
    FaCalendarAlt,
    FaTag,
    FaEdit,
    FaPaperPlane
} from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import './CreateTransactionForm.css';

export class CreateTransactionForm extends Component {
    bookId = JSON.parse(localStorage.bookId);
    userData = JSON.parse(localStorage["user-data"]);

    constructor(props) {
        super(props);
        this.state = {
            Id: props.data?.transaction_id || '',
            assetId: props.data?.asset_id || '',
            bookId: this.bookId,
            show: props.show,
            desc: props.data?.desc || '',
            transactionType: props.data?.transactionType || props.transactionType || '',
            amount: props.data?.amount ? Math.abs(props.data.amount) : '',
            categoryId: props.data?.category_id || '',
            validated: false,
            active: props.data?.active || true,
            edit: props.edit || false,
            assets: props.assets || [],
            categories: props.categories || [],
            transactionDate: props.data?.date ? new Date(props.data.date.replace(" ", "T")) : new Date(),
            user_id: this.userData.user_id,
            active_month: props.active_month,
            prevAmount: props.data?.amount || 0,
            loading: false,
            error: null,
            success: false
        }
    }

    componentDidMount() {
        if (this.props.transactionType) {
            this.setState({ transactionType: this.props.transactionType });
        }
    }

    getFilteredAssets = () => {
        return this.state.assets.filter(asset => 
            asset.type === '1' && asset.active === '1' && asset.category === '1'
        );
    }

    getFilteredCategories = () => {
        if (!this.state.transactionType) return [];
        
        return this.state.categories.filter(category => 
            category.type === (this.state.transactionType === "pendapatan" ? '1' : '2')
        );
    }

    handleChangeDate = (date) => {
        this.setState({ transactionDate: date });
    };

    formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    getFirstDateOfMonth = (dateString) => {
        const [year, month] = dateString.split('-').map(Number);
        return new Date(year, month - 1, 1);
    }
    getLastDateOfMonth(dateString) {
        const [year, month] = dateString.split('-').map(Number);
        return new Date(year, month, 0);
    }
    getTransactionDate(dateString){
        const [year, month] = this.state.active_month.split('-').map(Number);
        if( month<dateString.getMonth()+1 || year<dateString.getFullYear()){
            this.setState({transactionDate:new Date(year, month, 0)})
            return new Date(year, month, 0);
        }else{
            return dateString
        }
            
    }

    getTransactionTypeColor = () => {
        switch(this.state.transactionType) {
            case 'pendapatan': return 'success';
            case 'pengeluaran': return 'danger';
            case 'transfer': return 'info';
            default: return 'secondary';
        }
    }

    getTransactionTypeIcon = () => {
        switch(this.state.transactionType) {
            case 'pendapatan': return <FaMoneyBillWave />;
            case 'pengeluaran': return <FaWallet />;
            case 'transfer': return <FaExchangeAlt />;
            default: return <FaMoneyBillWave />;
        }
    }

    validateForm = () => {
        const { assetId, categoryId, amount, transactionDate, desc } = this.state;
        
        if (!assetId || !amount || !transactionDate || !desc) {
            return false;
        }
        
        if (this.state.transactionType !== 'transfer' && !categoryId) {
            return false;
        }
        
        return true;
    }

    saveTransaction = async (e) => {
        e.preventDefault();
        
        if (!this.validateForm()) {
            this.setState({ validated: true, error: "Harap lengkapi semua field yang wajib diisi" });
            return;
        }

        this.setState({ loading: true, error: null, success: false });

        try {
            let amount = this.state.transactionType === "pengeluaran" 
                ? -Math.abs(this.state.amount) 
                : Math.abs(this.state.amount);

            const transactionData = {
                assetId: this.state.assetId,
                bookId: this.state.bookId,
                desc: this.state.desc,
                categoryId: this.state.categoryId,
                amount: amount,
                transactionDate: new Date(this.state.transactionDate),
            };

            if (this.state.edit) {
                transactionData.Id = this.state.Id;
                transactionData.prevAmount = this.state.prevAmount;
                await this.props.updateTransaction(transactionData);
            } else {
                await this.props.createTransaction(transactionData);
            }

            this.setState({ success: true, loading: false });
            setTimeout(() => {
                this.props.handleClose();
            }, 1000);

        } catch (error) {
            console.error("Error saving transaction:", error);
            this.setState({ 
                error: "Gagal menyimpan transaksi. Silakan coba lagi.", 
                loading: false 
            });
        }
    }

    render() {
        const filteredAssets = this.getFilteredAssets();
        const filteredCategories = this.getFilteredCategories();
        const isTransfer = this.state.transactionType === 'transfer';

        return (
            <div className="transaction-form-modern">
                <Card className="transaction-card">
                    <Card.Header className="transaction-header">
                        <div className="d-flex align-items-center">
                            <span className="transaction-icon me-3">
                                {this.getTransactionTypeIcon()}
                            </span>
                            <div>
                                <h4 className="mb-0 text-capitalize">
                                    {this.state.transactionType}
                                </h4>
                                <Badge bg={this.getTransactionTypeColor()} className="mt-1">
                                    {this.state.edit ? 'Edit Transaksi' : 'Transaksi Baru'}
                                </Badge>
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body>
                        {this.state.error && (
                            <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                                {this.state.error}
                            </Alert>
                        )}

                        {this.state.success && (
                            <Alert variant="success">
                                Transaksi berhasil {this.state.edit ? 'diperbarui' : 'disimpan'}!
                            </Alert>
                        )}

                        <Form 
                            id="createTransactionForm" 
                            validated={this.state.validated}  
                            onSubmit={this.saveTransaction}
                            className="transaction-form"
                        >
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            <FaWallet className="me-2" />
                                            Akun
                                        </Form.Label>
                                        <Form.Select 
                                            value={this.state.assetId} 
                                            onChange={(e) => this.setState({ assetId: e.target.value })} 
                                            
                                            required
                                            className="modern-select"
                                        >
                                            <option value="">Pilih Akun</option>
                                            {filteredAssets.map((item, index) => (
                                                <option key={index} value={item.asset_id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                {!isTransfer && (
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="form-label">
                                                <FaTag className="me-2" />
                                                Kategori
                                            </Form.Label>
                                            <Form.Select 
                                                value={this.state.categoryId} 
                                                onChange={(e) => this.setState({ categoryId: e.target.value })} 
                                                
                                                required
                                                className="modern-select"
                                            >
                                                <option value="">Pilih Kategori</option>
                                                {filteredCategories.map((item, index) => (
                                                    <option key={index} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            <FaCalendarAlt className="me-2" />
                                            Tanggal Transaksi
                                        </Form.Label>
                                        <DatePicker
                                            selected={this.getTransactionDate(this.state.transactionDate)}
                                            onChange={this.handleChangeDate}
                                            dateFormat="dd/MMM/yyyy"
                                            maxDate={this.getLastDateOfMonth(this.state.active_month)}
                                            minDate={this.getFirstDateOfMonth(this.state.active_month)}
                                            className="form-control modern-datepicker"
                                            
                                            popperPlacement="bottom-start"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            <FaMoneyBillWave className="me-2" />
                                            Jumlah
                                        </Form.Label>
                                        <CurrencyInput
                                            className="form-control modern-currency-input"
                                            placeholder="Masukkan jumlah"
                                            defaultValue={this.state.amount}
                                            decimalsLimit={2}
                                            intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                            onValueChange={(value) => this.setState({ amount: value })}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-4">
                                <Form.Label className="form-label">Deskripsi</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={this.state.desc}
                                    onChange={(e) => this.setState({ desc: e.target.value })}
                                    placeholder="Deskripsi transaksi..."
                                    className="modern-textarea"
                                    required
                                />
                            </Form.Group>

                            <div className="form-actions">
                                <Button
                                    variant="secondary"
                                    onClick={this.props.handleClose}
                                    className="action-btn"
                                    disabled={this.state.loading}
                                >
                                    Batal
                                </Button>
                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={this.state.loading}
                                    className="action-btn submit-btn"
                                >
                                    {this.state.loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Menyimpan...
                                        </>
                                    ) : (
                                        <>
                                            <FaPaperPlane className="me-2" />
                                            {this.state.edit ? 'Perbarui Transaksi' : 'Catat Transaksi'}
                                        </>
                                    )}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export class TransferForm extends Component {
    bookId = JSON.parse(localStorage.bookId);
    userData = JSON.parse(localStorage["user-data"]);

    constructor(props) {
        super(props);
        this.state = {
            assetIdFrom: props.data?.asset_id || '',
            assetIdTo: '',
            bookId: this.bookId,
            desc: props.data?.desc || 'Transfer antar akun',
            amount: props.data?.amount ? Math.abs(props.data.amount) : '',
            validated: false,
            assets: props.assets || [],
            transactionDate: new Date(),
            active_month: props.active_month,
            loading: false,
            error: null,
            success: false
        }
    }

    getFilteredAssets = () => {
        return this.state.assets.filter(asset => 
            asset.type === '1' && asset.active === '1' && asset.category === '1'
        );
    }

    generateRefId = () => {
        const timestamp = Date.now().toString(36);
        const random = Math.random().toString(36).substring(2, 6);
        return `ref_${timestamp}_${random}`;
    }

    saveTransfer = async (e) => {
        e.preventDefault();
        
        const { assetIdFrom, assetIdTo, amount } = this.state;
        
        if (!assetIdFrom || !assetIdTo || !amount || assetIdFrom === assetIdTo) {
            this.setState({ 
                validated: true, 
                error: assetIdFrom === assetIdTo 
                    ? "Akun asal dan tujuan tidak boleh sama" 
                    : "Harap lengkapi semua field yang wajib diisi" 
            });
            return;
        }

        this.setState({ loading: true, error: null, success: false });

        try {
            const reff_id = this.generateRefId();

            // Debit from source account
            await this.props.createTransaction({
                assetId: assetIdFrom,
                bookId: this.state.bookId,
                reff_id: reff_id,
                desc: this.state.desc,
                categoryId: 0,
                amount: -Math.abs(amount),
                transactionDate: new Date(this.state.transactionDate),
            });

            // Credit to destination account
            await this.props.createTransaction({
                assetId: assetIdTo,
                bookId: this.state.bookId,
                reff_id: reff_id,
                desc: this.state.desc,
                categoryId: 0,
                amount: Math.abs(amount),
                transactionDate: new Date(this.state.transactionDate),
            });

            this.setState({ success: true, loading: false });
            setTimeout(() => {
                this.props.handleClose();
            }, 1000);

        } catch (error) {
            console.error("Error saving transfer:", error);
            this.setState({ 
                error: "Gagal melakukan transfer. Silakan coba lagi.", 
                loading: false 
            });
        }
    }
    getFirstDateOfMonth = (dateString) => {
        const [year, month] = dateString.split('-').map(Number);
        return new Date(year, month - 1, 1);
    }
    getLastDateOfMonth(dateString) {
        const [year, month] = dateString.split('-').map(Number);
        return new Date(year, month, 0);
    }

    render() {
        const filteredAssets = this.getFilteredAssets();

        return (
            <div className="transaction-form-modern">
                <Card className="transfer-card">
                    <Card.Header className="transfer-header">
                        <div className="d-flex align-items-center">
                            <FaExchangeAlt className="transaction-icon me-3" />
                            <div>
                                <h4 className="mb-0">Transfer Antar Akun</h4>
                                <Badge bg="info" className="mt-1">Transfer Dana</Badge>
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body>
                        {this.state.error && (
                            <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                                {this.state.error}
                            </Alert>
                        )}

                        {this.state.success && (
                            <Alert variant="success">
                                Transfer berhasil dilakukan!
                            </Alert>
                        )}

                        <Form onSubmit={this.saveTransfer} className="transfer-form">
                            <Row>
                                <Col md={5}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            <FaWallet className="me-2" />
                                            Dari Akun
                                        </Form.Label>
                                        <Form.Select 
                                            value={this.state.assetIdFrom} 
                                            onChange={(e) => this.setState({ assetIdFrom: e.target.value })} 
                                            required
                                            className="modern-select"
                                        >
                                            <option value="">Pilih Akun Asal</option>
                                            {filteredAssets.map((item, index) => (
                                                <option key={index} value={item.asset_id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={2} className="text-center">
                                    <div className="transfer-arrow">
                                        <FaArrowRight size={24} className="text-muted mt-4" />
                                    </div>
                                </Col>

                                <Col md={5}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            <FaWallet className="me-2" />
                                            Ke Akun
                                        </Form.Label>
                                        <Form.Select 
                                            value={this.state.assetIdTo} 
                                            onChange={(e) => this.setState({ assetIdTo: e.target.value })} 
                                            required
                                            className="modern-select"
                                        >
                                            <option value="">Pilih Akun Tujuan</option>
                                            {filteredAssets
                                                .filter(asset => asset.asset_id !== this.state.assetIdFrom)
                                                .map((item, index) => (
                                                    <option key={index} value={item.asset_id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            <FaCalendarAlt className="me-2" />
                                            Tanggal Transfer
                                        </Form.Label>
                                        <DatePicker
                                            selected={this.state.transactionDate}
                                            onChange={(date) => this.setState({ transactionDate: date })}
                                            dateFormat="dd/MMM/yyyy"
                                            maxDate={this.getLastDateOfMonth(this.state.active_month)}
                                            minDate={this.getFirstDateOfMonth(this.state.active_month)}
                                            className="form-control modern-datepicker"
                                            popperPlacement="bottom-start"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            <FaMoneyBillWave className="me-2" />
                                            Jumlah Transfer
                                        </Form.Label>
                                        <CurrencyInput
                                            className="form-control modern-currency-input"
                                            placeholder="Masukkan jumlah transfer"
                                            defaultValue={this.state.amount}
                                            decimalsLimit={2}
                                            intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                            onValueChange={(value) => this.setState({ amount: value })}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-4">
                                <Form.Label className="form-label">Keterangan</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    value={this.state.desc}
                                    onChange={(e) => this.setState({ desc: e.target.value })}
                                    placeholder="Keterangan transfer..."
                                    className="modern-textarea"
                                />
                            </Form.Group>

                            <div className="form-actions">
                                <Button
                                    variant="secondary"
                                    onClick={this.props.handleClose}
                                    className="action-btn"
                                    disabled={this.state.loading}
                                >
                                    Batal
                                </Button>
                                <Button
                                    type="submit"
                                    variant="info"
                                    disabled={this.state.loading}
                                    className="action-btn submit-btn"
                                >
                                    {this.state.loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Memproses...
                                        </>
                                    ) : (
                                        <>
                                            <FaExchangeAlt className="me-2" />
                                            Catat Transfer
                                        </>
                                    )}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}
